import { HttpHeaders } from '@angular/common/http';

export class HttpUtils {

  public static buildOptions(params: any): { headers: HttpHeaders; params: any } {
    return {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params
    };
  }

  public static buildListParams(offset?: number, limit?: number): { offset: string; limit: string } | {} {
    if (offset != null && limit != null) {
      return {
        offset: offset.toString(),
        limit: limit.toString()
      };
    }
    return {};
  }

}
